import { Box, Text, Link, Heading, Skeleton, useColorModeValue, Table, Thead, Tbody, Tr, Th, Td, TableContainer, IconButton } from '@chakra-ui/react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { format } from 'date-fns'

export function ResultadoConsulta({ dados, isLoading }) {
  const bgBox = useColorModeValue('white', 'gray.700')
  const borderColor = useColorModeValue('gray.200', 'gray.600')

  if (isLoading) {
    return (
      <Box width="100%" maxWidth="1200px" mx="auto">
        <Skeleton height="200px" width="100%" mb={4} />
      </Box>
    )
  }

  if (!dados || dados.length === 0) {
    return (
      <Box textAlign="center" p={10}>
        <Heading size="md" mb={4} color="gray.500">
          Nenhum resultado encontrado
        </Heading>
        <Text>Faça uma nova consulta com outro código de produto.</Text>
      </Box>
    )
  }

  return (
    <Box
      width="100%"
      maxWidth="1200px"
      mx="auto"
      boxShadow="md"
      borderRadius="lg"
      overflow="hidden"
      bg={bgBox}
      borderWidth="1px"
      borderColor={borderColor}
    >
      <Box bg="#378BBF" color="white" py={3} px={4}>
        <Heading size="md">Layouts de Referência - Produto: {dados[0]?.codigo_produto}</Heading>
      </Box>

      <TableContainer>
        <Table variant="simple">
          <Thead bg="gray.50">
            <Tr>
              <Th>Número do Pedido</Th>
              <Th>Nome do Cliente</Th>
              <Th>Data do Layout</Th>
              <Th textAlign="center">Link do Layout</Th>
            </Tr>
          </Thead>
          <Tbody>
            {dados.map((item, index) => (
              <Tr key={`${item.numero_pedido}-${index}`}>
                <Td fontWeight="medium">{item.numero_pedido}</Td>
                <Td>{item.nome_cliente}</Td>
                <Td>{item.data_solicitacao ? format(new Date(item.data_solicitacao), 'dd/MM/yyyy HH:mm') : 'N/A'}</Td>
                <Td textAlign="center">
                  <Link href={item.link_layout} isExternal _hover={{ textDecoration: 'none' }}>
                    <IconButton aria-label="Ver layout" icon={<ExternalLinkIcon />} colorScheme="blue" size="sm" variant="outline" />
                  </Link>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
